<template>
  <div class="doc-api-page">
    <div class="page-title">{{title}}</div>
    <div class="search-box">
      <el-form ref="searchForm" size="small"
               :model="searchObj"
               label-position="left"
               label-width="auto">
        <el-form-item label="业务分类">
          <el-select class="width-full" v-model="searchObj.business_id" 
                     placeholder="请选择应用类型" @change="businessChange">
            <el-option v-for="item in appTypeList" :key="item.id" :label="item.business_name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="content-body">
      <div class="api-list-box">
        <div v-for="item in apiList" :key="item.id"
             :class="['app-list-item', {'active': apiDetail.id === item.id}]" @click="apiItemClick(item)">
          {{item.interface_name}}
        </div>
        <div class="no-data-box" v-if="!apiList.length">暂无数据...</div>
      </div>
      <div class="api-content-box" v-if="apiDetail.interface_name">
        <div class="part-title">基本信息</div>
        <div class="part-content">
          <div class="info-row">
            <div class="info-label">接口名</div>
            <div class="info-value">
              <span>{{apiDetail.interface_name}}</span>
              <el-tag type="warning" size="small" class="ml-sm tag-position-top" v-if="apiDetail.is_auth">需用户授权</el-tag>
            </div>
          </div>
          <div class="info-row mt-sm">
            <div class="info-label">api_method</div>
            <div class="info-value">{{apiDetail.request_virtual}}</div>
          </div>
          <div class="info-row mt-sm">
            <div class="info-label">请求方式</div>
            <div class="info-value text-warning">{{apiDetail.request_method === 1 ? 'GET' : 'POST'}}</div>
          </div>
          <div class="info-row mt-sm">
            <div class="info-label">接口简介</div>
            <div class="info-value">{{apiDetail.interface_desc}}</div>
          </div>
        </div>
        <template v-if="headerDataList && headerDataList.length">
          <div class="part-title">Header说明</div>
          <div class="part-content" v-if="detailShow">
            <el-table
                :data="headerDataList"
                class="no-border-table"
                size="mini"
                style="width: 100%">
              <el-table-column prop="code" label="Header" width="144"></el-table-column>
              <el-table-column prop="desc" label="说明"></el-table-column>
            </el-table>
          </div>
        </template>
        <div class="part-title">请求参数</div>
        <div class="part-content doc-table-box" v-if="detailShow">
          <el-table
              :data="requestDataList"
              border
              size="mini"
              row-key="id"
              default-expand-all
              :tree-props="{children: 'children'}"
              style="width: 100%">
            <el-table-column label="参数名称" min-width="150">
              <template slot-scope="scope">
                <span class="el-table__placeholder" v-if="!scope.row.children || !scope.row.children.length"></span>
                <span :class="[{'text-warning': scope.row.importance === 'required'}]">{{scope.row.name}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="type" label="类型" width="100"></el-table-column>
            <el-table-column prop="desc" label="描述" min-width="250"></el-table-column>
          </el-table>
        </div>
        <div class="part-title">响应参数</div>
        <div class="part-content doc-table-box" v-if="detailShow">
          <el-table
              :data="responseDataList"
              border
              size="mini"
              row-key="id"
              default-expand-all
              :tree-props="{children: 'children'}"
              style="width: 100%">
            <el-table-column label="参数名称" min-width="150">
              <template slot-scope="scope">
                <span class="el-table__placeholder xxx" v-if="!scope.row.children || !scope.row.children.length"></span>
                <span :class="[{'text-warning': scope.row.importance === 'required'}]">{{scope.row.name}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="type" label="类型" width="100"></el-table-column>
            <el-table-column prop="desc" label="描述" min-width="250"></el-table-column>
          </el-table>
        </div>
        <template v-if="requestExample">
          <div class="part-title">请求示例</div>
          <div class="part-content">
            <div class="json-box">
              <hll-json-box :json-data="requestExample"></hll-json-box>
            </div>
          </div>
        </template>
        <template v-if="responseExample">
          <div class="part-title">响应示例</div>
          <div class="part-content">
            <div class="json-box">
              <hll-json-box :json-data="responseExample"></hll-json-box>
            </div>
          </div>
        </template>
        <template v-if="codeDataList && codeDataList.length">
          <div class="part-title">状态码</div>
          <div class="part-content" v-if="detailShow">
            <el-table
                :data="codeDataList"
                class="no-border-table"
                size="mini"
                style="width: 100%">
              <el-table-column prop="code" label="状态值" width="144"></el-table-column>
              <el-table-column prop="desc" label="描述"></el-table-column>
            </el-table>
          </div>
        </template>
        <template v-if="apiDetail.extend_desc">
          <div class="part-title">补充信息</div>
          <div class="part-content" style="padding-top: 5px;">
            <hll-doc :data="apiDetail.extend_desc"></hll-doc>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import {commonJsonParse} from '../../assets/js/common'
  import HllJsonBox from '../common/hll-json-box'
  import HllDoc from '../common/hll-doc'
  
  export default {
    name: 'docApi',
    data() {
      return {
        routeObj: {
          appType: '', // 从路由来的指定应用类型
          apiId: '' // 从路由来的指定api
        },
        searchObj: {
          business_id: ''
        },
        appTypeList: [], // 应用类型列表
        apiList: [], // 接口列表
        detailShow: true,
        apiDetail: {},
        headerDataList: [],
        requestDataList: [],
        responseDataList: [],
        codeDataList: [],
        requestExample: {},
        responseExample: {},
        title: '',
      }
    },
    components: {
      HllJsonBox,
      HllDoc
    },
    watch: {
      '$route.query'(newVal, oldVal) {
        if(newVal.type !== oldVal.type) {
          this.routeObj.appType = Number(newVal.type);
          this.routeObj.apiId = Number(newVal.id);
          this.searchObj.business_id = this.routeObj.appType;
          this.businessChange();
        } else {
          if(newVal.id !== oldVal.id) {
            this.routeObj.apiId = Number(newVal.id);
            this.setDefaultApi();
          }
        }
      }
    },
    mounted() {
      if(this.$route.query.type) {
        this.routeObj.appType = Number(this.$route.query.type);
      }
      if(this.$route.query.id) {
        this.routeObj.apiId = Number(this.$route.query.id);
      }
      this.getAppTypeList();
    },
    beforeUpdate() {
      this.init();
    },
    methods: {
      init() {
        this.initFlag = true;
        this.$store.state.app.menuList.forEach(el => {
          if(el.id === Number(this.$route.query.menu)) {
            this.title = el.title;
            document.title = el.title;
          }
        });
      },
      // 获取应用类型列表
      getAppTypeList() {
        this.$axios.post("/ajax/api/doc/business/list", {}).then(res => {
          this.appTypeList = res.data.data;
          if(this.appTypeList.length) {
            let tempType =this.appTypeList[0].id;
            if(this.routeObj.appType !== '') {
              this.appTypeList.forEach(val => {
                if(val.id === this.routeObj.appType) {
                  tempType = val.id;
                }
              })
            }
            this.searchObj.business_id = tempType;
            this.getApiList();
          }
        });
      },
      // 获取应用类型下的接口列表
      getApiList() {
        this.$axios.post("/ajax/api/doc/business/interface", {
          business_id: this.searchObj.business_id,
          page_size: 10000,
          page_no: 1
        }).then(res => {
          this.apiList = res.data.data.list;
          this.setDefaultApi();
        });
      },
      // 设置默认选中的api
      setDefaultApi() {
        if(!this.apiList || !this.apiList.length) {
          return ;
        }
        let tempApi = this.apiList[0];
        // 当url中的类型与searchObj中的类型不一致 表示未找到指定的类型 则不匹配指定的api
        if(this.routeObj.apiId !== '' && this.searchObj.business_id === this.routeObj.appType) {
          this.apiList.forEach(val => {
            if(val.id === this.routeObj.apiId) {
              tempApi = val;
            }
          })
        }
        this.apiItemClick(tempApi);
      },
      // 应用类型选择变化
      businessChange() {
        this.apiDetail = {};
        this.headerDataList = [];
        this.requestDataList = [];
        this.responseDataList = [];
        this.codeDataList = [];
        this.requestExample = {};
        this.responseExample = {};
        this.getApiList();
      },
      // 设置接口详情
      apiItemClick(item) {
        if(this.apiDetail.id === item.id) {
          return ;
        }
        // 由于表格数据变化存在未重新render的情况 此处通过控制v-if="detailShow"强制刷新一遍
        this.detailShow = false;
        setTimeout(() => {
          this.detailShow = true;
        }, 10);
        this.apiDetail = item;
        this.headerDataList = commonJsonParse(item.request_header, []);
        this.requestDataList = commonJsonParse(item.request_data, []);
        this.responseDataList = commonJsonParse(item.response_data, []);
        this.codeDataList = commonJsonParse(item.code_example, []);
        this.requestExample = item.request_example;
        this.responseExample = item.response_example;
        // 当点击api-item时，更新url，确保页面刷新时能定位到当前api。若用户直接通过改变url进入当前页面则无需刷新url
        let query = this.$route.query;
        if(Number(query.type) !== this.searchObj.business_id || Number(query.id) !== item.id) {
          this.$router.replace({
            path: `/doc/api?menu=${this.$route.query.menu}&type=${this.searchObj.business_id}&id=${item.id}`
          })
        }
      }
    }
  }
</script>' +

<style lang="scss">
  .doc-table-box {
    .el-table--mini,
    .el-table--small,
    .el-table__expand-icon {
      font-size: 13px;
    }
    .el-table__placeholder {
      margin-left: 1px;
      position: relative;
      &:before {
        content: '';
        position: absolute;
        top: -14px;
        left: 50%;
        margin-left: -1px;
        width: 0;
        height: 20px;
        border-left: 1px dashed #ccc;
      }
      &+.el-table__placeholder {
        display: none;
      }
    }
    .el-table__expand-icon {
      margin-right: 1px !important;
    }
  }
</style>
<style lang="scss" scoped>
  .doc-api-page {
    width: 1170px;
    padding: 0 0 30px;
    margin: 0 auto;
  }
  .page-title {
    width: 100%;
    height: 28px;
    line-height: 28px;
    font-size: 18px;
    color: #212121;
    text-align: center;
    margin: 24px 0;
  }
  .content-body {
    position: relative;
    min-height: 500px;
    margin-top: 25px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
  }
  .no-data-box {
    line-height: 30px;
    text-align: center;
    color: #666;
    font-size: 13px;
  }
  .api-list-box {
    position: absolute;
    top: 0;
    left: 0;
    width: 237px;
    height: 100%;
    padding-top: 20px;
    background: #F4F5F6;
    box-sizing: border-box;
    overflow: hidden;
    overflow-y: auto;
    .app-list-item {
      width: 100%;
      min-height: 40px;
      line-height: 18px;
      color: #212121;
      font-size: 14px;
      padding: 11px 20px 11px 20px;
      border-left: 3px solid transparent;
      box-sizing: border-box;
      cursor: pointer;
      &.active {
        color: #F16622;
        background: #fff;
        border-left-color: #F16622;
      }
    }
  }
  .api-content-box {
    width: 100%;
    padding: 22px 25px 25px 270px;
    box-sizing: border-box;
    .part-title {
      width: 100%;
      line-height: 35px;
      color: #424456;
      font-size: 15px;
      padding-left: 2px;
      border-bottom: 1px solid #F2F2F2;
      font-weight: bold;
    }
    .part-content {
      width: 100%;
      padding: 15px 3px 20px 5px;
      box-sizing: border-box;
    }
    .info-row {
      color: #212121;
      font-size: 14px;
      line-height: 24px;
      .info-label {
        display: inline-block;
        width: 90px;
        vertical-align: top;
      }
      .info-value {
        display: inline-block;
        width: 600px;
        vertical-align: top;
        color: #666;
      }
      .info-tag {
        display: inline-block;
        width: 60px;
        height: 24px;
        font-size: 12px;
        line-height: 24px;
        text-align: center;
        background: #E4E6F4;
        border-radius: 2px;
        transform: scale(.88);
        transform-origin: left;
        margin-right: -5px;
      }
      .tag-position-top {
        position: relative;
        top: -1px;
      }
    }
    .json-box {
      padding: 15px;
      max-height: 520px;
      font-size: 13px;
      line-height: 15px;
      background: #F7F7F7;
      box-sizing: border-box;
      overflow: auto;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/doc/api.vue